export default "__VITE_ASSET__CGofVIOf__"